import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirRocket, iconoirWarningTriangle, iconoirXmark } from '@ng-icons/iconoir';
import { TrialBannerService } from '../../../services/trial-banner.service';
import { BtnComponent } from '../buttons/btn/btn.component';

@Component({
  selector: 'app-trial-ending-banner',
  standalone: true,
  imports: [NgIcon, BtnComponent, RouterLink],
  templateUrl: './trial-ending-banner.component.html',
  styleUrl: './trial-ending-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideIcons({ iconoirWarningTriangle, iconoirRocket, iconoirXmark })]
})
export class TrialEndingBannerComponent {
  public trialBannerService = inject(TrialBannerService);
}
